/**
 * Extend Bootstrap table with tables without visible borders
 */
.table.table-noborders {
  border: 0;
  thead,
  tbody,
  tfoot {
    > tr.message {
      > th,
      > td {
        border: 0;
      }
    }
  }
}
